import type { MouseEvent, ReactNode } from "react"
import { useI18n } from "../i18n/useI18n"

type FilterValueButtonProps = {
  children: ReactNode
  className?: string
  filterKey: string
  filterValue: string
  onAppendFilter: (
    key: string,
    value: string,
    options?: { negate?: boolean },
  ) => void
  title?: string
}

export function FilterValueButton({
  children,
  className,
  filterKey,
  filterValue,
  onAppendFilter,
  title,
}: FilterValueButtonProps) {
  const { t } = useI18n()
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (!(event.metaKey || event.ctrlKey || event.altKey)) {
      return
    }

    event.preventDefault()
    event.stopPropagation()
    onAppendFilter(filterKey, filterValue, { negate: event.altKey })
  }

  return (
    <button
      className={className ?? "table-filter-link"}
      onClick={handleClick}
      title={title ?? t("filter.appendValueTitle")}
      type="button"
    >
      {children}
    </button>
  )
}
